var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 13.5q.088 0 .172.016l.021.003.047.011.05.013.059.02.029.011q.036.015.07.033l.017.007.011.006q.028.016.053.033l.02.012.01.006a1 1 0 0 1 .382.496l.015.04.016.062q.027.111.028.231v6a1 1 0 0 1-2 0v-3.586l-5.293 5.293a1 1 0 1 1-1.414-1.414L7.586 15.5H4a1 1 0 0 1 0-2zM20.293 2.793a1 1 0 1 1 1.414 1.414L16.414 9.5H20a1 1 0 0 1 0 2h-6q-.085-.002-.166-.015l-.031-.005-.035-.008-.061-.016-.04-.014-.052-.02-.026-.012a1 1 0 0 1-.546-.619l-.013-.05a1 1 0 0 1-.03-.24v-6a1 1 0 1 1 2 0v3.585z"
  })));
};
export default Svg24;